module.exports = __webpack_public_path__ + "img/NS2-logo-blue.1194a6af.svg";